export default __webpack_public_path__ + "static/media/student-work5.7f45bb70.jpeg";